import Papa from 'papaparse';

export async function loadCsvData() {
    const response = await fetch('/csv/Web_probability.csv');
    const text = await response.text();

    return new Promise((resolve, reject) => {
        Papa.parse(text, {
            header: true,
            dynamicTyping: true,
            complete: (results) => resolve(results.data),
            error: (err) => reject(err)
        });
    });
}

